import { render, staticRenderFns } from "./PersonProfileMasterTransactionInformation.vue?vue&type=template&id=76dcc45e&scoped=true&"
import script from "./PersonProfileMasterTransactionInformation.vue?vue&type=script&lang=js&"
export * from "./PersonProfileMasterTransactionInformation.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileMasterTransactionInformation.vue?vue&type=style&index=0&id=76dcc45e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dcc45e",
  null
  
)

export default component.exports